import { Logger } from '@lib.core/logger/logger';

export class LoggerService {
  private static loggerServiceInstance: LoggerService;
  private loggers: Logger[] = [];

  private constructor() {
    // use LoggerService.getLoggerService()
  }

  public static getLoggerService() {
    if (this.loggerServiceInstance === undefined) {
      this.loggerServiceInstance = new LoggerService();
    }
    return this.loggerServiceInstance;
  }

  public addLogger(logger: Logger) {
    if (!this.loggers.includes(logger)) {
      this.loggers.push(logger);
    }
    return this;
  }

  public fatal(err: Error) {
    const entity = new LogEntity(err.message, LogSeverity.Fatal, err.stack);
    this.notifyLoggers(entity);
    throw err;
  }

  public error(err: Error) {
    const entity = new LogEntity(err.message, LogSeverity.Error, err.stack);
    this.notifyLoggers(entity);
  }

  public warning(message: string) {
    const entity = new LogEntity(message, LogSeverity.Warning);
    this.notifyLoggers(entity);
  }

  public debug(message: string) {
    const entity = new LogEntity(message, LogSeverity.Debug);
    this.notifyLoggers(entity);
  }

  public info(message: string) {
    const entity = new LogEntity(message, LogSeverity.Information);
    this.notifyLoggers(entity);
  }

  private notifyLoggers(logEntity: LogEntity) {
    this.loggers.forEach(l => l.log(logEntity));
  }
}

export enum LogSeverity {
  Information,
  Debug,
  Warning,
  Error,
  Fatal,
  None,
}

export class LogEntity {
  constructor(public message: string, public severity: LogSeverity, public stack?: string) {
  }
}
